class MFRBundle {
  constructor(data) {
    this.$element = $('body')

    this.selectors = {
      addButton: '[data-mfr-add-to-bundle]',
      removeButton: '[data-mfr-remove-to-bundle]',
      bundleSection: '[data-mfr-bundle-section]',
      bundler: '[data-mfr-bundler]',
      submit: '[data-mfr-bundler-submit]',
      subscription: '[name="subscription_type"]',
      removeBundleFromCart: '[data-mfr-remove-bundle]',
      limitSwitch: '[data-mfr-limit-switch]',
      limitSwitchWrapper: '[data-mfr-limit-switch-wrapper]',
      productCard: '[data-bundle-product-card]',
      bundlerVisualizer: "[data-mfr-bundler-visualizer]",
      bundlerVisualizerWrapper: "[data-mfr-bundler-visualizer-wrapper]",
      visualizerImage: "[data-mfr-bundler-visualizer-image] img",
      countIndicator: "[data-mfr-count-indicator]",
      countIndicatorWrapper: "[data-mfr-count-indicator-wrapper]"
    }

    window.mfrBundle = [];

    this.limit = data.limit ?? 0;

    this.maxPerProduct = data.maxPerProduct
    this.minimumProducts = data.minimumProducts ?? 0;
    this.updateLimit();

    this.init()
  }

  init() {
    this.$bundleSection = this.$element.find(this.selectors.bundleSection);

    if (this.$bundleSection.length) this.initBundler()

    $(document).on('click', this.selectors.addButton, this.__handleAddButtonClick.bind(this))
    $(document).on('click', this.selectors.removeButton, this.__handleRemoveButtonClick.bind(this))
    $(document).on('click', this.selectors.removeBundleFromCart, this.__handleRemoveBundleFromCart.bind(this))
    $(document).on('click', this.selectors.limitSwitch, this.__handleLimitSwitchClick.bind( this ) );
  }

  __handleAddButtonClick(e) {
    e.preventDefault()

    if (this.limit <= this.getBundleQuantity() && this.limit > 0) return

    const variantID = $(e.currentTarget).attr('data-mfr-add-to-bundle')
    const price = $(e.currentTarget).data('mfr-bundle-price')
    const selling_plan = $(e.currentTarget).data('mfr-bundle-selling_plan')
    const quantity = 1;
    // const visualizerImage = $( e.currentTarget ).closest( this.selectors.productCard ).find( this.selectors.visualizerImage ).clone();

    // BRENDAN –––––– show indicator and remove button
    const parent = $(e.currentTarget).closest( this.selectors.productCard )
    const indicatorWrapper = parent.find( this.selectors.countIndicatorWrapper );
    const indicator = parent.find( this.selectors.countIndicator )

    indicatorWrapper.css( "display", "flex" );
    indicator.text(parseInt(indicator.text()) + 1)
    
    $(document).trigger("mfr-bundle:product-added", {
      element: $(e.currentTarget).closest("[data-bundle-product-card]"),
      id: variantID
    });
    // BRENDAN END

    // window.mfrBundle[variantID] = {
    //   quantity: quantity,
    //   price: price,
    //   selling_plan: selling_plan,
    //   visualizerImage: visualizerImage
    // }

    window.mfrBundle.push({
      id: variantID,
      quantity: quantity,
      price: price,
      selling_plan: selling_plan,
      // visualizerImage: visualizerImage
    });

    $(document).trigger('mfr-bundle:bundle-changed',[
      {
        add: variantID
      }
    ])
  }

  __handleRemoveButtonClick(e) {
    e.preventDefault();

    // BRENDAN –––––– reset and hide indicator and remove button
    const parent = $(e.currentTarget).closest(this.selectors.productCard);
    const indicatorWrapper = parent.find(this.selectors.countIndicatorWrapper);
    const indicator = parent.find(this.selectors.countIndicator);

    const variantID = $(e.currentTarget).attr("data-mfr-remove-to-bundle");

    $(window.mfrBundle.reverse()).each((i, e) => {
      if (e.id == variantID) {
        window.mfrBundle.splice(i, 1);
        return false;
      }
    });
    window.mfrBundle.reverse();

    indicator.text(parseInt(indicator.text()) - 1 );
    if( parseInt(indicator.text()) <= 0 ) indicatorWrapper.hide();
    // if (!variantIsInObject) {
    //   // delete window.mfrBundle[variantID];
    //   $(document).trigger("mfr-bundle:product-removed", {
    //     element: $(e.currentTarget).closest("[data-bundle-product-card]"),
    //   });
    //   indicatorWrapper.hide();
    //   indicator.text(0);
    // } else {
    //   window.mfrBundle[variantID].quantity =
    //     window.mfrBundle[variantID].quantity - 1;
    //   indicator.text(window.mfrBundle[variantID].quantity);
    // }

    $(document).trigger("mfr-bundle:product-removed", {
      element: $(e.currentTarget).closest("[data-bundle-product-card]"),
      quantity: indicator.text(),
    });

    $(document).trigger("mfr-bundle:bundle-changed", [
      {
        remove: variantID,
      },
    ]);
  }

  __handleRemoveBundleFromCart(e) {
    const $button = $(e.currentTarget)
    const bundleHash = $button.attr('data-mfr-remove-bundle') //dont use data(), it will not work if rivets doesnt bind the data and just added attribute to the html
    const items = CartJS.cart.items
    let productsToRemove = {}

    //get all key with same properties._bundle_hash
    $.each(items, (index, item) => {
      const itemBundleHash = item.properties._bundle_hash
      if (itemBundleHash == bundleHash) {
        productsToRemove[item.key] = 0
      }
    })

    $('.cart-form').addClass('loading')
    this.processRemove(items, bundleHash)
    this.resetProductCards()
  }

  __handleLimitSwitchClick(e) {
    const beforeLimit = this.limit;
    $( e.currentTarget ).closest( this.selectors.limitSwitchWrapper ).find( this.selectors.limitSwitch ).removeClass( "is-active" );
    $( e.currentTarget ).addClass( "is-active" );
    this.limit = $( e.currentTarget ).data( "mfr-limit-switch" );
    this.minimumProducts = $( e.currentTarget ).data( "mfr-limit-switch" );
    // this.minimumProducts = $( `.is-active${ this.selectors.limitSwitch }` ).data( "mfr-limit-switch" );
    // this.limit = $( `.is-active${ this.selectors.limitSwitch }` ).data( "mfr-limit-switch" );
    
    if( beforeLimit > this.limit && window.mfrBundle.length > this.limit ) {
      const elementsToRemove = Math.abs(window.mfrBundle.length - this.limit);
      const startingIndex = window.mfrBundle.length - elementsToRemove;
      const removedProducts = window.mfrBundle.splice(startingIndex, beforeLimit);
      this.removeIndicators(removedProducts);
    }
    
    $(document).trigger("mfr-bundle:bundle-changed");
    this.updateItems();
    // this.resetBundler();
    this.updateVisualizer();
    // this.resetIndicators();
  }

  removeIndicators( products ) {
    $.each( products, ( i, product ) => {
      const card = $(`[data-bundle-product-card="${product.id}"]`);
      const indicatorWrapper = card.find(this.selectors.countIndicatorWrapper);
      const indicator = card.find(this.selectors.countIndicator);
      indicator.text(parseInt(indicator.text()) - 1);
      if (parseInt(indicator.text()) <= 0) indicatorWrapper.hide();
      $(document).trigger("mfr-bundle:product-removed", {
        element: card,
        quantity: indicator.text(),
      });
    } )
  }

  resetIndicators() {
    const parent = $( this.selectors.productCard )
    const indicatorWrapper = parent.find( this.selectors.countIndicatorWrapper )
    const indicator = parent.find( this.selectors.countIndicator )
    
    indicatorWrapper.hide()
    indicator.text(0)
    $( document ).trigger( "mfr-bundle:reset" )
  }

  updateLimit() {
    const limitSwitch = this.$element.find( this.selectors.limitSwitch );
    if( !limitSwitch.length ) return;

    this.minimumProducts = $( `.is-active${ this.selectors.limitSwitch }` ).data( "mfr-limit-switch" );
    this.limit = $( `.is-active${ this.selectors.limitSwitch }` ).data( "mfr-limit-switch" );
  }

  updateVisualizer() {
    $( this.selectors.bundlerVisualizerWrapper ).each( ( i, e ) => {
      const visualizers = $( e ).find( this.selectors.bundlerVisualizer );
      const state = Flip.getState( visualizers );
      const wrapperState = Flip.getState( $( e ) );

      visualizers.removeClass( "show" );
      visualizers.each( ( index, element ) => {
        if( index <= this.limit - 1 ) $( element ).addClass( "show" );
      } );

      Flip.from( state, {
        scale: true,
        absoluteOnLeave: false,
        stagger: 0.4,
        ease: "back",
        onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1, duration: 0.4}),
        onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0, duration: 0.4})
      } );

      Flip.from( wrapperState, {
        duration: .4,
        scale: true
      } );
    } )
  }

  processRemove(items, hash) {
    let foundObject = items.find((object) => object.properties._bundle_hash == hash)
    let payload = {}
    payload[foundObject.key] = 0

    if (foundObject) {
      $.ajax({
        type: 'POST',
        url: window.Shopify.routes.root + 'cart/update.js',
        data: {
          updates: payload,
        },
        dataType: 'json',
        success: (e) => {
          if (e.items.find((object) => object.properties._bundle_hash == hash)) {
            this.processRemove(e.items, hash)
          } else {
            CartJS.getCart()
          }
        },
        error: (e) => {
          console.log('error', e)
        },
      })
    } else {
      CartJS.getCart()
    }
  }

  getBundleQuantity() {
    let quantity = 0
    if (!Object.keys(window.mfrBundle).length) return quantity

    $.each(window.mfrBundle, (i, e) => {
      quantity += e.quantity
    })

    return quantity
  }

  getBundlePrice() {
    let price = 0
    if (!Object.keys(window.mfrBundle).length) return price

    $.each(window.mfrBundle, (i, e) => {
      price += parseFloat(e.price * e.quantity)
    })

    return price
  }

  getDiscountedPrice() {
    if( !$(`[name="subscription_type"]:checked`).length ) return this.getBundlePrice().toFixed(2);
    const subscriptionType = $(`[name="subscription_type"]:checked`)
    const discount = subscriptionType.data('mfr-bundle-discount') / 100
    return (this.getBundlePrice() - this.getBundlePrice() * discount).toFixed(2)
  }

  enableDisableButtons() {
    // if (this.limit <= this.getBundleQuantity() && this.limit > 0) {
    //   $(this.selectors.addButton).addClass('disabled')
    //   $.each(window.mfrBundle, (variant_id, quantity) => {
    //     this.changeToRemove(variant_id)
    //   })
    // } else {
    //   $(this.selectors.addButton).removeClass('disabled')
    // }
    $(this.selectors.addButton).prop(
      "disabled",
      this.limit <= this.getBundleQuantity() && this.limit > 0
    );
  }

  // BRENDAN –––––– reset and hide indicators and remove buttons
  resetProductCards() {
    $('.bundle-product__count').each(function () {
      $(this).text(0)
      $(this).hide()
    })
    $('.bundle-product__remove').each(function () {
      $(this).hide()
    })
  }
  // BRENDAN END

  changeToRemove(variantID) {
    this.$element
      .find(`[data-mfr-add-to-bundle="${variantID}"]`)
      .removeClass('disabled')
      .removeClass('add')
      .removeAttr('data-mfr-add-to-bundle')
      .addClass('remove')
      .attr('data-mfr-remove-to-bundle', variantID)
      .find('.text')
      .text('Remove')
  }

  changeToAdd(variantID) {
    this.$element
      .find(`[data-mfr-remove-to-bundle="${variantID}"]`)
      .removeClass('disabled')
      .removeClass('remove')
      .removeAttr('data-mfr-remove-to-bundle')
      .addClass('add')
      .attr('data-mfr-add-to-bundle', variantID)
      .find('.text')
      .text('add')
  }

  initBundler() {
    this.$bundler = this.$element.find(this.selectors.bundler)
    this.$submit = this.$element.find(this.selectors.submit)
    this.$subscription = this.$element.find(this.selectors.subscription)

    this.$bundleSection.each( ( i, e ) => {
      const scrollTrigger = ScrollTrigger.create( {
        trigger: $( e ),
        start: "top center",
        endTrigger: "footer",
        end: "center bottom",
        onEnter: () => this.$bundler.addClass( "show" ),
        onEnterBack: () => this.$bundler.addClass( "show" ),
        onLeave: () => this.$bundler.removeClass( "show" ),
        onLeaveBack: () => this.$bundler.removeClass( "show" )
      } );
    } );

    this.updateItems()

    $(document).on('mfr-bundle:bundle-changed', this.__handleBundleChange.bind(this))
    this.$subscription.on('change', (e) => {
      this.updatePrice()
    })
    this.$submit.on('click', this.__handleBundlerSubmit.bind(this))
  }

  __handleBundleChange(e, data) {
    const wrapper = $( this.selectors.bundlerVisualizerWrapper );
    const bundles = window.mfrBundle ?? [];

    wrapper.each( ( i, wrapper ) => {
      const images = $( wrapper ).find( this.selectors.bundlerVisualizer );
      
      images
        .removeClass( "is-active" )
        .data( "variant-id", "" )
        .find( "img" )
        .remove();

      $.each( bundles, ( i, bundle ) => this.addVisualizerImage( wrapper, bundle["id"]) );
    } );
    // if( data.add ) {
    //   this.addVisualizerImage(data.add);
    // }
    // else if( data.remove ) {
    //   this.removeVisualizerImage(data.remove);
    // }

    this.updateItems()
  }

  addVisualizerImage( wrapper, id ) {
      const firstAvailableVisualizer = $( wrapper ).find( `${this.selectors.bundlerVisualizer}.show:not(.is-active)` ).get(0);

      $(firstAvailableVisualizer)
        .addClass("is-active")
        .data("variant-id", id)
        .append($(`[data-mfr-bundler-visualizer-image='${ id }'] img`).clone());

      // gsap.from( $( firstAvailableVisualizer ).find( "img" ), {
      //   opacity: 0,
      //   ease: "back",
      //   duration: .4
      // } );
  }

  removeVisualizerImage( id ) {
    $( this.selectors.bundlerVisualizerWrapper ).each( ( index, wrapper ) => {
      $($(wrapper).find(this.selectors.bundlerVisualizer).get().reverse()).each((i, e) => {
        if ($(e).data("variant-id") == id) {
          $(e)
            .data("variant-id", "")
            .removeClass("is-active")
            .find("img")
            .remove();
          return false;
        }
      });
    } );
  }

  resetVisualizerImages() {
    $( this.selectors.bundlerVisualizerWrapper ).each( ( i, wrapper ) => {
      if( !$( wrapper ).find( this.selectors.bundlerVisualizer ).find( "img" ).length ) return;
      gsap.to( $( wrapper ).find( this.selectors.bundlerVisualizer ).find( "img" ), {
        stagger: 0.1,
        opacity: 0,
        onComplete: () => {
          $( wrapper ).find( this.selectors.bundlerVisualizer )
            .data( "variant-id", undefined )
            .removeClass( "is-active" )
            .find( "img" ).remove()
        }
      } );
    } );
  }

  __handleBundlerSubmit(e) {
    if (this.minimumProducts != this.getBundleQuantity()) return
    const bundle = window.mfrBundle
    let payload = []
    const subscriptionType = $(`[name="subscription_type"]:checked`)
    const bundleHash = this.generateID()

    $.each(bundle, (i, e) => {
      let properties = {
        _bundle_hash: bundleHash,
        _added_by: 'MFR Bundle Builder',
      }

      let args = {
        id: e.id,
        quantity: e.quantity,
      }

      if (subscriptionType.val() == 'subscription' && e.selling_plan) {
        args['selling_plan'] = e.selling_plan
        properties['_selling_plan_id'] = e.selling_plan
      }

      args['properties'] = properties
      
      if ( payload.filter((item) => item.id == e.id).length )
        payload = payload.map( item => {
          if( item.id == e.id ) {
            item.quantity += e.quantity;
          }

          return item;
        } );
      else 
        payload.push(args);
    })

    if (CartJS) {
      if (CartJS.addItems) {
        CartJS.addItems([...payload])
      }
    }

    this.resetBundler()
  }

  updateItems() {
    this.updateRemainingItems()
    this.updatePrice()
  }

  updateRemainingItems() {
    const value = this.$submit.find('.quantity').find('.value')
    const remaining = this.minimumProducts - this.getBundleQuantity()

    if (remaining == 0) {
      this.$submit.find('.quantity').hide()
      this.$submit.find('.add-to-cart-text').show()
      this.$submit.removeClass('disabled')
    } else {
      this.$submit.find('.quantity').show()
      this.$submit.find('.add-to-cart-text').hide()
      this.$submit.addClass('disabled')
    }
    this.enableDisableButtons();

    value.text(this.minimumProducts - this.getBundleQuantity())
  }

  updatePrice() {
    const value = this.$submit.find('.price').find('.value')

    value.text(this.getDiscountedPrice())
  }

  generateID() {
    return 'mfr-bundle-' + Math.floor(Date.now() / 1000).toString(16) + Math.random().toString(16).substr(2, 8)
  }

  resetBundler() {
    window.mfrBundle = []

    // this.$element.find(this.selectors.removeButton).each((i, e) => {
    //   const element = $(e)
    //   const variantID = element.attr('data-mfr-remove-to-bundle')

    //   this.changeToAdd(variantID)
    // })
    // this.$element.find(this.selectors.addButton).removeClass('disabled')

    this.updateItems()
    this.resetProductCards()
    this.resetVisualizerImages();
    this.resetIndicators();
  }
}
